



















































import { Component, Vue, Prop } from 'vue-property-decorator';

import { User } from '@/models/User';

@Component({
    name: 'UserTable',
})
export default class UserTable extends Vue {
    @Prop(Array) private users: User[];
    @Prop(Boolean) private isLoading: boolean;
}
